import { Component } from "react";

import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles/InputTextWithIcon.module.scss";
import FlatIcon from "../../utilities/FlatIcon";
import FontAwesome from "../../utilities/FontAwesome";

export default class InputTextWithIcon extends Component {
    static propTypes = {
        icon: PropTypes.string,
        autocomplete: PropTypes.string,
        placeholder: PropTypes.string,
        className: PropTypes.string,
        type: PropTypes.string,
        value: PropTypes.string,
        onChange: PropTypes.func,
        name: PropTypes.string,
        iconType: PropTypes.oneOf(['fontawesome', 'flaticon']),
        ariaLabel: PropTypes.string.isRequired,
    };

    static defaultProps = {
        type: "text",
        placeholder: "",
        value: "",
        iconType: 'flaticon',
        autocomplete: '',
    };

    render() {
        const inputTextWithIconClassName = classNames({
            [styles.inputTextWithIcon]: true,
            [this.props.className]: this.props.className,
        });

        let icon;
        if (this.props.icon) {
            switch (this.props.iconType) {
                case 'flaticon':
                    icon = <FlatIcon ariaHidden={true} name={this.props.icon}/>;
                    break;
                case 'fontawesome':
                    icon = <FontAwesome ariaHidden={true} name={this.props.icon} />;
                    break;
                default:
                    icon = "";
            }
        }

        return (
            <div className={inputTextWithIconClassName}>
                {icon}
                <div>
                    <input
                        aria-label={this.props.ariaLabel}
                        autoComplete={this.props.autocomplete}
                        name={this.props.name}
                        onChange={this.props.onChange}
                        value={this.props.value}
                        type={this.props.type}
                        placeholder={this.props.placeholder}
                    />
                </div>
                {this.props.children}
            </div>
        );
    }
}
